module.exports = __webpack_public_path__ + "img/ArborDayFoundation.857abcc1.png";